import { Box, Link, useTokens } from '@barracuda-internal/bds-core-v2'
import React, { useCallback, useMemo } from 'react'
import config from 'config/appConfig'
import routesConfig from 'lib/routesConfig'
import { useFormatMessage } from 'lib/localization'
import emailLogPaths from 'config/uipaths/emailLogPaths'
import { isMyFeatureOn } from 'lib/splitio'
import { FEATURES } from 'lib/splitioFeatures'

const BASE_I18N_KEY = 'ess.email_protection'

const CMLLink = () => {
  const tokens = useTokens()
  const formatMessage = useFormatMessage(BASE_I18N_KEY)

  const onClick = useCallback((e: React.MouseEvent) => {
    e.stopPropagation()
    e.preventDefault()
    routesConfig.EMAIL_LOG.goto()
  }, [])

  const shouldRedirectToStandaloneCML = isMyFeatureOn(FEATURES.EGD_React_Converged_Message_Log_Standalone)

  return useMemo(
    () => (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-end'
        }}
      >
        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
        <Link
          sx={{
            zIndex: 3001,
            marginRight: tokens.aliasesSpaceComponentSpacious,
            marginTop: tokens.aliasesSpaceComponentDefault,
            marginBottom: tokens.aliasesSpaceComponentDefault
          }}
          underline="always"
          href={
            shouldRedirectToStandaloneCML
              ? config.CONVERGED_MESSAGE_LOG_URL
              : `/${config.APP_NAMES.ADMIN}/${emailLogPaths.EMAIL_LOG.path}`
          }
          onClick={shouldRedirectToStandaloneCML ? undefined : onClick}
        >
          {formatMessage('link')}
        </Link>
      </Box>
    ),
    [
      formatMessage,
      onClick,
      shouldRedirectToStandaloneCML,
      tokens.aliasesSpaceComponentDefault,
      tokens.aliasesSpaceComponentSpacious
    ]
  )
}

export default CMLLink
